var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 632,
    height: 635,
    viewBox: "0 0 632 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_1690)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -412,
    y: -1650,
    width: 1440,
    height: 3789,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-636.21 662.79L310.055 337.873L-14.8623 1284.14L-961.127 1609.05L-636.21 662.79Z",
    fill: "#FFFFEF",
    stroke: "#BDBD25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128.454 -562.466L309.361 337.148L-669.448 129.974L-1107.26 -769.641L-128.454 -562.466Z",
    fill: "#FFE1E1",
    stroke: "#FE6363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.55 129.974L310.737 337.148L748.552 -562.466L1727.36 -769.64L1289.55 129.974Z",
    fill: "#F7EDFF",
    stroke: "#BC68FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.276 -562L309.916 336.861L-129.443 -562L309.916 -1460.86L749.276 -562Z",
    fill: "#FFE8F6",
    stroke: "#FF6DC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.004 1238.5L308.823 334.703L1212.62 701.884L1579.8 1605.68L676.004 1238.5Z",
    fill: "#F2FFFF",
    stroke: "#1ABFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-129.443 1239L309.916 340.139L749.275 1239L309.916 2137.86L-129.443 1239Z",
    fill: "#E8FED6",
    stroke: "#59A61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-589 -101.443L309.861 337.916L-589 777.275L-1487.86 337.916L-589 -101.443Z",
    fill: "#FEEDD6",
    stroke: "#C67811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209 777.276L310.139 337.916L1209 -101.443L2107.86 337.916L1209 777.276Z",
    fill: "#F3F6FF",
    stroke: "#88A6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_1690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 632,
    height: 635,
    rx: 316,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK2);
export default __webpack_public_path__ + "static/media/K2.3ff3ab3baae09d5833727d8c442b9b44.svg";
export { ForwardRef as ReactComponent };